import { CreateDeviceStore } from "./device-store.types";

export const createDeviceStore: CreateDeviceStore = (set) => ({
  deviceType: "",
  isMobile: false,
  checkDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const isMobile = isTouchDevice || /android|iphone|ipad|ipod/.test(userAgent);
    return set(
      (state) => ({
        ...state,
        isMobile,
        deviceType: userAgent,
      }),
      false,
      "device/checkDevice"
    );
  },
});
